import React from "react";
import { Link } from "react-router-dom";
import blogPosts from "./blogPosts";

export default function BlogListPage() {
    return (
        <div className="max-w-3xl mx-auto px-4 py-16">
            <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">Blog</h1>
                <p className="text-gray-500">Tips and insights on building wealth and reaching financial independence</p>
            </div>

            <div className="space-y-8">
                {blogPosts.map((post) => (
                    <Link key={post.slug} to={`/blog/${post.slug}`} className="block">
                        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8 hover:border-gray-300 transition-colors">
                            <span className="text-sm font-medium text-accent-600">{post.date}</span>
                            <h2 className="text-xl font-bold text-gray-900 mt-1 mb-2">{post.title}</h2>
                            <p className="text-gray-500 text-sm mb-3">{post.preview}</p>
                            <span className="text-accent-600 text-sm font-medium">Read more &rarr;</span>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
